import { render, staticRenderFns } from "./BasicPrefs.vue?vue&type=template&id=5a174d6d&scoped=true&"
import script from "./BasicPrefs.vue?vue&type=script&lang=js&"
export * from "./BasicPrefs.vue?vue&type=script&lang=js&"
import style0 from "./BasicPrefs.vue?vue&type=style&index=0&id=5a174d6d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a174d6d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCard,VCardActions,VCardText,VCardTitle,VTextField})
